import type {
  AgentSessionAdminQueryInput,
  AgentSessionAdminSummary,
  AgentSessionFilterMode,
  AgentSessionMessages,
  AgentSessionSummary,
  CreateAgentSessionRequest,
  DeleteAgentSessionResponse,
  UpdateAgentSessionRequest,
} from 'agentic-platform-schema';

import { type Common } from './common.js';

export class API {
  common: Common;
  readonly baseEndpoint = '/agentic-platform/sessions';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllAdmin(query?: AgentSessionAdminQueryInput): Promise<AgentSessionAdminSummary[]> {
    const url = this.common.constructPath('/agentic-platform/admin/sessions', query);
    return await this.common.getJSON(url);
  }

  async findAllAdminMessages(sessionId: string): Promise<AgentSessionMessages> {
    const url = this.common.constructPath(
      `/agentic-platform/admin/sessions/${encodeURIComponent(sessionId)}/messages`
    );
    return await this.common.getJSON(url);
  }

  async findAll(options: { filterMode: AgentSessionFilterMode }): Promise<AgentSessionSummary[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOne(sessionId: string): Promise<AgentSessionSummary> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${encodeURIComponent(sessionId)}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateAgentSessionRequest): Promise<AgentSessionSummary> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(args: {
    sessionId: string;
    values: UpdateAgentSessionRequest;
  }): Promise<AgentSessionSummary> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${encodeURIComponent(args.sessionId)}`
    );
    return await this.common.patchJSON(url, args.values);
  }

  async delete(sessionId: string): Promise<DeleteAgentSessionResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${encodeURIComponent(sessionId)}`);
    return await this.common.deleteJSON(url);
  }

  async findAllMessages(sessionId: string): Promise<AgentSessionMessages> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${encodeURIComponent(sessionId)}/messages`
    );
    return await this.common.getJSON(url);
  }
}
